import React from 'react';
import { SERIES_FORMATS, TITLES, autoStatus } from '../../services/tripleCrown';
import { fmtDate } from '../../utils/championshipDates';

/* ── Championship list card ── */
export default function ChampionshipCard({ championship, onClick }) {
  const status = autoStatus(championship.startDate, championship.endDate);
  const formatLabel = SERIES_FORMATS.find(f => f.id === championship.seriesFormat)?.label || 'Points-Based';
  const titles = (championship.titles || []).map(id => TITLES.find(t => t.id === id)?.short || id);

  return (
    <div
      className="card"
      onClick={onClick}
      style={{
        cursor: 'pointer', transition: 'all 0.15s',
        borderLeft: status === 'active' ? '3px solid var(--success)' : status === 'upcoming' ? '3px solid var(--teal)' : '3px solid var(--border)',
      }}
      onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.03)'; }}
      onMouseLeave={e => { e.currentTarget.style.background = ''; }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 6 }}>{championship.title}</div>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 8 }}>
            <span className={`badge ${status === 'active' ? 'badge-success' : status === 'completed' ? 'badge-gold' : 'badge-teal'}`}>
              {status}
            </span>
            <span className="badge badge-muted">{formatLabel}</span>
            {titles.map(t => (
              <span key={t} className="badge badge-muted" style={{ fontSize: 10 }}>{t}</span>
            ))}
          </div>
          <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>
            {fmtDate(championship.startDate)} — {fmtDate(championship.endDate)}
          </div>
        </div>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ color: 'var(--text-muted)', flexShrink: 0, marginTop: 4 }}>
          <polyline points="9 6 15 12 9 18" />
        </svg>
      </div>
    </div>
  );
}
